export const MAX_UPLOAD_LONG_SIDE = 2500

function canvasToBlob (canvas, type, quality) {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob) {
                resolve(blob)
            } else {
                reject(new Error('画像の変換に失敗しました'))
            }
        }, type, quality)
    })
}

function loadHtmlImage (file) {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file)
        const image = new Image()

        image.onload = () => {
            URL.revokeObjectURL(url)
            resolve(image)
        }
        image.onerror = () => {
            URL.revokeObjectURL(url)
            reject(new Error('画像を読み込めませんでした'))
        }
        image.src = url
    })
}

async function loadOrientedImage (file) {
    if (typeof createImageBitmap === 'function') {
        try {
            return await createImageBitmap(file, { imageOrientation: 'from-image' })
        } catch (e) {
            try {
                return await createImageBitmap(file)
            } catch (fallbackError) {
                // HTMLImageElement のフォールバックへ進む。
            }
        }
    }

    return loadHtmlImage(file)
}

export async function optimizeImageForUpload (file, maxLongSide = MAX_UPLOAD_LONG_SIDE) {
    const supportedTypes = ['image/jpeg', 'image/png', 'image/webp']
    if (supportedTypes.indexOf(file.type) === -1) return file

    const image = await loadOrientedImage(file)
    const width = image.width || image.naturalWidth
    const height = image.height || image.naturalHeight
    const longSide = Math.max(width, height)

    if (!width || !height || longSide <= maxLongSide) {
        if (typeof image.close === 'function') image.close()
        return file
    }

    const scale = maxLongSide / longSide
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(width * scale))
    canvas.height = Math.max(1, Math.round(height * scale))

    const context = canvas.getContext('2d')
    if (!context) {
        if (typeof image.close === 'function') image.close()
        throw new Error('画像処理を開始できませんでした')
    }

    context.drawImage(image, 0, 0, canvas.width, canvas.height)
    if (typeof image.close === 'function') image.close()

    const outputType = file.type
    const blob = await canvasToBlob(canvas, outputType, 1)

    return new File([blob], file.name, {
        type: outputType,
        lastModified: file.lastModified
    })
}



// WEBPACK FOOTER //
// ./src/helpers/image.js